import instance from "./endpoint";


// get profile
export const getProfile = async () => {
    const response = await instance.get("api/v1/superadmin/auth/profile", {});
    return response.data;
};

// get all users
export const getAllUsers = async () => {
    const response = await instance.get("/api/v1/auth/getAllUsers");
    return response.data;
};

// get all admins
export const getAllAdmins = async () => {
    const response = await instance.get("/api/v1/admin/auth/getAllAdmins");
    return response.data;
};

// get all deposit requests
export const getalldepositReq = async () => {
    const response = await instance.get("/api/v1/deposit/getalldepositReq");
    return response.data;
};

//get all withdraw requests
export const getallwithdrawReq = async () => {
    const response = await instance.get("/api/v1/withdraw/getallWithdrawalReq");
    return response.data;
};

// get kyc docs
export const getKycDocs = async () => {
    const response = await instance.get("/api/v1/kycproof/getAllKycProofs");
    return response.data;
};

// Get all Referrals (superadmin)
export const getAllReferrals = async () => {
    try {
        const response = await instance.get("/api/v1/referrals/fetchAllReferrals");
        return response.data;
    } catch (error) {
        console.error("Error fetching referrals:", error);
        throw error;
    }
};


// update admin profile fullname
export const updateProfile = async ({ FullName }) => {
    return await instance.put("/api/v1/superadmin/auth/profile", {FullName});
};

// api to update password
export const changePassword = async ({ oldPassword, newPassword }) => {
    try {
      const response = await instance.put("/api/v1/superadmin/auth/changePassword", {
        oldPassword,
        newPassword,
      });
      return response.data;
    } catch (error) {
      console.error("Error changing password:", error);
      throw error;
    }
  };


  //get all loan agreements (admin and superadmin)
export const getAllLoanAgreements = async () => {
    try {
        const response = await instance.get("api/v1/generateDoc/loanallagreements");
        return response.data;
    } catch (error) {
        console.error("Error fetching loan agreements:", error);
        throw error;
    }
};
